import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export enum DatePickerFormats {
  datepickerFormat = 'datepickerFormat',
  datePickerPlaceHolderText = 'datePickerPlaceHolderText',
}

export type LocaleDatePickerFormatResult = {
  dateFormat: string;
  placeHolderText: string;
};

export const useLocaleDatePickerFormat = (): LocaleDatePickerFormatResult => {
  const { t } = useTranslation('_dateFormats');

  return useCallback((): LocaleDatePickerFormatResult => {
    return {
      dateFormat: t(DatePickerFormats.datepickerFormat, 'dd MMM yyyy'),
      placeHolderText: t(DatePickerFormats.datePickerPlaceHolderText, 'DD MMM YYYY'),
    };
  }, [t])();
};
